import PropTypes from 'prop-types';
import React from 'react';
import { LinearProgress, makeStyles } from '@material-ui/core';
import { useTheme } from 'styled-components';

const useStyles = makeStyles({
  root: ({ colors, milestones, currentPercent, hideMilestone }) => {
    const getBackgroundImage = () => {
      const color = colors?.myPath?.primary?.[300];
      const greater = (milestones || [])?.filter(
        (m) => m.pos > currentPercent && m.pos > 0 && m.pos < 100
      );
      const nearest = greater.length ? Math.min(...greater.map((m) => m.pos)) : 100;
      return hideMilestone
        ? ''
        : `linear-gradient(to right, ${color} ${nearest}%, transparent ${nearest}%)`;
    };

    return {
      height: '8px',
      borderRadius: '24px',
      overflow: 'hidden',
      backgroundColor: colors?.myPath?.gray?.[100],
      backgroundImage: getBackgroundImage(),
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100% 100%',
    };
  },
  bar: ({ colors }) => ({
    backgroundColor: colors?.myPath?.primary?.[500],
  }),
});

/* The track + nearest-milestone highlight you already had */
function ProgressBar({ milestones, currentPercent, hideMilestone, ...props }) {
  const { colors } = useTheme();
  const classes = useStyles({ colors, milestones, currentPercent, hideMilestone });

  return <LinearProgress variant="determinate" classes={classes} {...props} />;
}

ProgressBar.propTypes = {
  milestones: PropTypes.array,
  currentPercent: PropTypes.number,
  hideMilestone: PropTypes.bool,
};

export default ProgressBar;
